import { makeStyles } from 'tss-react/mui';

type StyleParams = {
  isM1Enabled: boolean;
};

const useStyles = makeStyles<StyleParams>()((theme, { isM1Enabled }) => ({
  header: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    minHeight: isM1Enabled ? 88 : 72,
    padding: isM1Enabled ? theme.new.spacing.large : theme.new.spacing.medium,
    borderBottom: isM1Enabled
      ? 'none'
      : `1px solid ${theme.new.color.line.hairline}`,
    backgroundColor: isM1Enabled ? 'transparent' : theme.new.color.common.white,
  },
  title: {
    ...theme.typography.header2_medium,
    color: theme.new.color.textPrimary,
    margin: 0,
  },
  actions: {
    display: 'flex',
    alignItems: 'center',
    gap: theme.new.spacing.small,
  },
  iconButton: {
    width: 40,
    height: 40,
    color: theme.new.color.textPrimary,
    padding: 0,
    transition: theme.transitions.create(['background-color', 'color']),
    '&:hover': {
      backgroundColor: theme.new.color.brand[100],
    },
    // Toggle-style active state for the new-conversation edit icon: a
    // brand-100 circular fill with brand-600 ink to mirror the Figma
    // pressed treatment while the in-chat reset confirmation is open.
    '&[data-active="true"]': {
      backgroundColor: theme.new.color.brand[100],
      color: theme.new.color.brand[600],
    },
  },
}));

export default useStyles;
